export default function generator (startingId: number = 0) {
  return () => startingId++
}
